<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>商品欠货列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="输入搜索：">
                  <el-input
                    v-model="form.goods_no"
                    placeholder="商品货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.goods_kh"
                    placeholder="商品款号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.goods_name"
                    placeholder="商品名称"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.market_name"
                    placeholder="市场"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.city"
                    multiple
                    placeholder="请选择商家城市"
                  >
                    <el-option
                      v-for="item in citys"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.brand_name"
                    placeholder="品牌"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.woid"
                    placeholder="代采单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select v-model="form.pg_id" placeholder="选择买手组">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.optionPicker"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.pgid"
                    placeholder="选择代采组"
                    multiple
                    filterable
                  >
                    <el-option
                      v-for="item in resData.optionPurchase"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.transfer_type"
                    placeholder="选择来源"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.optionTransferType"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select v-model="form.referer_type" placeholder="欠货类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.optionRefererType"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select v-model="form.jy_type" placeholder="交易类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.optionJyType"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.order_owner"
                    multiple
                    filterable
                    placeholder="订单负责人"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.option_order_owner"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.order_paied"
                    placeholder="是否已支付"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option label="已支付" value="1"></el-option>
                    <el-option label="未支付" value="2"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.dgid"
                    filterable
                    multiple
                    placeholder="次品组"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.dg_group"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.dpc_id"
                    filterable
                    multiple
                    placeholder="退换货负责人"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.option_dgm"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.ptype"
                    filterable
                    placeholder="计划类型"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.option_ptype"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.planid"
                    placeholder="计划id"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.refunder_id"
                    filterable
                    multiple
                    placeholder="售后退供员"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.dgm_refunder"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.order_type"
                    placeholder="代采开单方式"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option label="实单" value="1"></el-option>
                    <el-option label="排单" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pre_label"
                    placeholder="预处理方式"
                    multiple
                  >
                    <el-option
                      v-for="item in pre_label"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.wcg_pag_status"
                    placeholder="代采订单付款状态"
                  >
                    <el-option value="0" label="全部"></el-option>
                    <el-option
                      v-for="item in wcg_pag_status"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.owe_label"
                    placeholder="代采欠货标签"
                  >
                    <el-option value="0" label="全部"></el-option>
                    <el-option
                      v-for="item in oweLabelOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.stock_out_create_admin_str"
                    placeholder="扫码出库人"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding: 0 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="操作时间：">
                  <el-date-picker
                    v-model="form.time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="代采单时间：">
                  <el-date-picker
                    v-model="form.wcg_order_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="退换货生成时间">
                  <el-date-picker
                    v-model="form.stock_out_create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <el-row>
      <el-col v-if="resData" :span="24" class="data-statics">
        数据汇总&nbsp;&nbsp;&nbsp;&nbsp;
        <span
          >欠货数量：{{
            resData.total.num
          }}件&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
        >
        <span
          >欠货金额：¥{{
            resData.total.amount
          }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
        >
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div style="display: inline-block; width: 10%">数据列表：</div>
          <div style="display: inline-block; text-align: right; width: 90%">
            <el-button size="mini" type="primary" @click="restoreOwedGoods">
              退换货恢复欠货
            </el-button>
            <el-button size="mini" type="danger" @click="handleDelivery">
              在途转欠货
            </el-button>
            <el-button size="mini" type="info" @click="endWcg">
              结束代采
            </el-button>
            <el-button size="mini" type="info" @click="getReasonSelection">
              转坏账</el-button
            >
            <el-button size="mini" type="success" @click="output">
              导出</el-button
            >
          </div>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column align="center" type="selection"> </el-table-column>
            <el-table-column align="center" prop="goods_img" label="商品图片">
              <template #default="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    style="width: 100%; height: 100%"
                    :src="scope.row.goods_img[0]"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="planid" label="计划编号">
            </el-table-column>
            <el-table-column
              align="center"
              prop="wcg_plan_ptype"
              label="计划类型"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="goods_name"
              label="商品名称"
              width="180"
            >
              <template #default="{ row }">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="row.goods_name"
                  placement="top-start"
                >
                  <div class="ellipsis-2">{{ row.goods_name }}</div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_no"
              label="商品货号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_kh"
              label="商品款号"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="co_val"
              label="颜色"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="si_val"
              label="尺寸"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <!-- <el-table-column prop="num" label="数量" show-overflow-tooltip align="center"></el-table-column> -->
            <el-table-column
              prop="market_name"
              label="市场"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_city"
              label="城市"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="brand_name"
              label="品牌"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pg_name"
              label="买手组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="order_owner_name"
              filterable
              label="订单负责人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dg_group_name"
              filterable
              label="次品组"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dgm_name"
              filterable
              label="退换货负责人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="refunder"
              filterable
              label="售后退供员"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="woid"
              label="代采订单"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="order_create_time"
              label="提交时间"
              show-overflow-tooltip
              align="center"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="price"
              label="代采价"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="paid_price"
              label="实付价"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="jy_type"
              label="交易类型"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <!-- <el-table-column prop="owe_amount" label="欠货金额" show-overflow-tooltip align="center"> </el-table-column> -->
            <el-table-column
              prop="wcg_owe_record_transfer_type"
              label="来源"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="reject_referer_type"
              label="欠货类型"
              show-overflow-tooltip
              align="center"
            >
              <template #default="{ row }">
                <div>{{ row.reject_referer_type }}</div>
                <div v-if="row.is_transit_formal" style="color: #006cff">
                  {{ row.is_transit_formal }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="admin_name"
              label="操作人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="操作时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pay_time"
              label="支付时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="wcg_order_type"
              label="代采开单方式"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="status_time_formal"
              label="代采欠货标签更新"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_return_day"
              label="承诺回货时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pre_label"
              label="预处理标签"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="apply_img"
              label="预处理凭证"
              show-overflow-tooltip
              align="center"
            >
              <template #default="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    v-for="(item, key) in scope.row.pre_images"
                    :key="key"
                    :src="item"
                    style="max-width: 100%; max-height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="pre_remark"
              label="预处理备注"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pre_admin_name"
              label="预处理人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pre_create_time"
              label="预处理时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="stock_out_create_admin_str"
              label="扫码出库人"
              show-overflow-tooltip
              align="center"
              width="90"
            >
            </el-table-column>
            <el-table-column
              prop="stock_out_create_time"
              label="退换货生成时间"
              show-overflow-tooltip
              align="center"
              width="150"
            >
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper, sizes"
            :total="resData.count"
            :page-size.sync="form.psize"
            :page-sizes="[10, 50, 100]"
            @current-change="handleCurrentChange"
            @size-change="pageSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="debt.show_dialog"
      :close-on-click-modal="false"
      title="申请转坏账原因"
    >
      <el-cascader
        v-model="debt.reason"
        placeholder="请选择原因"
        :options="reason_selection"
        :props="{ expandTrigger: 'hover' }"
        filterable
      >
      </el-cascader>
      <br />
      <div style="margin-top: 20px">填写备注</div>
      <el-input
        v-model="debt.remark"
        type="textarea"
        placeholder="请填写备注"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="debt.show_dialog = false">取 消</el-button>
        <el-button type="primary" @click="toDebtBroken">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 在途转欠货 -->
    <el-dialog
      :visible.sync="isDeliveryModal"
      :close-on-click-modal="false"
      title="在途转欠货"
      width="680px"
      :before-close="closeDeliveryDialog"
    >
      <el-form
        ref="deliveryRef"
        :model="deliveryForm"
        label-position="top"
        label-width="100px"
      >
        <div>商家：{{ deliveryForm.supply_name }}</div>
        <div style="margin-top: 4px">
          共选择{{ deliveryForm.models }}款，{{
            deliveryForm.packages
          }}件，确定向商家申请转回代采欠货？
        </div>
        <el-form-item label="商家沟通凭证（最多3张）：" prop="imgs">
          <YsUpload v-model="deliveryForm.images" :max="3"></YsUpload>
        </el-form-item>
        <el-form-item label="" prop="reason">
          <YsInput
            v-model="deliveryForm.remark"
            placeholder="备注，非必填，最多20字"
            :maxlength="20"
            type="textarea"
            show-word-limit
            :autosize="{ minRows: 3, maxRows: 5 }"
          ></YsInput>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button @click="isDeliveryModal = false">取消</el-button>
        <el-button type="primary" @click="handleDeliveryConfirm">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { CITY } from "@/const/CommonConst.js";
import apiBaseURL from "@/utils/baseUrl.js";
import {
  postAddTurnOweApply,
  postExchangeReturnGoodsArrears,
} from "@/openapi/erp/deduction.js";

export default {
  data() {
    return {
      resData: null,
      form: {
        // wcg_order_time: this.defaultDate(),
        owe_label: "",
        status: "",
        ptype: "",
        psize: 10,
        city: [],
        pgid: [],
        order_create_time: [],
        wcg_order_time: [],
      },
      loading: false,
      tableLoading: false,
      url: "/erp/Deduction/goodsOweList",
      status: -1,
      curPage: 1,
      filterFold: false,
      reason_selection: [], // 转坏账原因
      multipleSelection: [],
      debt: {
        // 转坏账
        show_dialog: false,
        reason: [],
        remark: "",
      },
      citys: CITY,
      pre_label: [
        {
          label: "预抵扣",
          value: "1",
        },
        {
          label: "预呆账",
          value: "2",
        },
        {
          label: "预退款",
          value: "3",
        },
        {
          label: "预坏账",
          value: "4",
        },
      ],
      wcg_pag_status: [
        {
          label: "未支付",
          value: "2",
        },
        {
          label: "已支付",
          value: "1",
        },
      ],
      oweLabelOptions: [
        {
          label: "订单欠货",
          value: "1",
        },
        {
          label: "在途库存",
          value: "2",
        },
        {
          label: "异地在途库存",
          value: "3",
        },
      ],
      // 在途转欠货
      isDeliveryModal: false,
      deliveryForm: { images: [], remark: "" },
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  created() {
    this.form.pgid = (
      (this.$route.query.pg_group_id &&
        this.$route.query.pg_group_id.split(",")) ||
      []
    ).filter((item) => item);
    this.form.city = (
      (this.$route.query.city && this.$route.query.city.split(",")) ||
      []
    ).filter((item) => item);
    this.fetchData();
  },
  methods: {
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 15);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    fetchData(showLoading) {
      this.form.is_excel = 0;
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit() {},
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.multipleSelection = [];
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    // 切换页面条数
    pageSizeChange() {
      this.curPage = 1;
      this.handleCurrentChange(this.page);
    },
    handleClick(row) {
      this.$router.push(`/home/purchaseorderdetail/${row.woid}`);
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          (this.status = this.filteredForm.status), (this.curPage = 1);
        }
      });
    },
    selectStatus(key) {
      this.loading = true;
      this.form.status = this.status = key;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },

    // 获取转坏账原因
    getReasonSelection() {
      if (this.multipleSelection.length == 0) {
        return this.$message.e("请先勾选数据");
      }
      this.debt.reason = [];
      this.debt.remark = "";
      if (this.reason_selection.length > 0) {
        this.debt.show_dialog = true;
        return;
      }
      this.$http.post("/erp/Deduction/getDebtsReason").then((rs) => {
        if (rs.data.code != 200) {
          return this.$message.e(rs.data.msg);
        }
        this.reason_selection = rs.data.data;
        this.debt.show_dialog = true;
      });
    },

    // 转坏帐
    toDebtBroken() {
      if (this.debt.reason.length == 0) {
        return this.$message.e("请选择坏账原因");
      }
      // console.log(this.debt);
      const list = [];
      this.multipleSelection.forEach((v) => {
        list.push({
          woiid: v.woiid,
          reject_id: v.reject_id,
          num: 1,
        });
      });
      this.$http
        .post("/erp/Deduction/toBrokenDebts", {
          transfer_data: list,
          reason_id: this.debt.reason[1], // 只取二级原因
          remark: this.debt.remark,
        })
        .then((rs) => {
          if (rs.data.code != 200) {
            return this.$message.error(rs.data.msg);
          }
          this.$message.success(rs.data.msg);
          this.fetchData();
          this.debt.show_dialog = false;
        });
    },

    // 结束代采
    endWcg() {
      if (this.multipleSelection.length == 0) {
        return this.$message.e("请先勾选数据");
      }
      if (this.multipleSelection.length > 100) {
        return this.$message.e("一次操作不能超过100条数据");
      }

      // 组装数据
      const list = [];
      const goods_ks = [];
      this.multipleSelection.forEach((v) => {
        list.push({
          woiid: v.woiid,
          reject_id: v.reject_id,
          woid: v.woid,
        });
        if (!goods_ks.includes(v.goods_no)) {
          goods_ks.push(v.goods_no);
        }
      });

      this.$confirm(
        `结束代采: 共${goods_ks.length}款, ${list.length}件`,
        "提示",
        {
          "close-on-click-modal": false,
        }
      ).then((_) => {
        this.$http.post("/erp/Deduction/endWcg", { list }).then((rs) => {
          if (rs.data.code != 200) {
            return this.$message.e(rs.data.msg);
          }
          this.$message.success(rs.data.msg);
          this.fetchData();
        });
      });
    },
    // 退换货恢复欠货
    restoreOwedGoods() {
      // 欠货ID  爆版4.53.0 判断是否符合  欠货类型为“代采退换”or“售后退换”or“售后退供”，且代采欠货标签为“在途库存”or“异地在途库存”的数据
      const isAllOweIds = this.multipleSelection.every(
        (item) =>
          item.is_transit === "2" && [1, 2, 3].includes(item.referee_type)
      );
      if (!isAllOweIds) {
        this.$message.e("包含非在途数据，请重新检查再提交");
        return;
      }
      const oweIds = this.multipleSelection.map((item) => item.id);
      // 无数据
      if (oweIds.length === 0) {
        this.$message.e(
          "请勾选代采欠货标签为“在途库存”or“异地在途库存”的商品数据"
        );
        return;
      }
      // console.log("oweIds", this.multipleSelection, oweIds);
      this.$confirm(
        `是否将当前勾选商品恢复成欠货？ 共${oweIds.length}件`,
        "提示",
        {
          "close-on-click-modal": false,
        }
      ).then(() => {
        postExchangeReturnGoodsArrears({ owe_ids: oweIds }).then(() => {
          this.$message.success("处理成功");
          this.fetchData();
        });
      });
    },
    // 在途转欠货
    handleDelivery() {
      // 无数据
      if (this.multipleSelection.length === 0) {
        this.$message.e("请先勾选数据");
        return;
      }
      // 勾选数量超过3000
      if (this.multipleSelection.length >= 3000) {
        this.$message.e("最多可选3000条，请重新选择");
        return;
      }
      // 同个商家
      const isSameSupplyId = this.multipleSelection.every(
        (item) => item.supply_id === this.multipleSelection[0].supply_id
      );
      if (!isSameSupplyId) {
        this.$message.e("不支持多个商家批量处理，请重新选择");
        return;
      }
      // 在途库存
      const isAllTransit = this.multipleSelection.every(
        (item) => item.is_transit === "2"
      );
      if (!isAllTransit) {
        this.$message.e("包含非在途库存的数据，请重新选择");
        return;
      }
      const { supply_name: supplyName } = this.multipleSelection[0];
      // 款数
      const models = [
        ...new Set(this.multipleSelection.map((item) => item.goods_no)),
      ].length;
      // 件数
      const packages = this.multipleSelection.length;
      // 欠货ID
      const oweIds = this.multipleSelection.map((item) => item.id);
      this.deliveryForm = {
        ...this.deliveryForm,
        supply_name: supplyName,
        owe_ids: oweIds,
        models,
        packages,
      };
      this.isDeliveryModal = true;
    },
    // 确认在途转欠货
    handleDeliveryConfirm() {
      const { remark, owe_ids: oweIds, images } = this.deliveryForm;
      // 整理图片
      const newImages = images.map((item) => {
        return item.url;
      });
      const params = {
        owe_ids: oweIds,
        images: newImages,
        remark,
      };
      postAddTurnOweApply(params).then(() => {
        this.$message.success("处理成功");
        this.isDeliveryModal = false;
        this.fetchData();
      });
    },
    // 关闭弹框
    closeDeliveryDialog() {
      this.isDeliveryModal = false;
      // 清空数据
      this.deliveryForm = this.$options.data().deliveryForm;
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.ellipsis-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/PurchaseGoodsToBeReturned.vue